<script>
import { VueEditor } from "vue2-editor";

import { eventBus } from "@/main";

import ConfirmationModalComponent from "@/modules/checkin-facility/pages/dashboard/components/confirmation-modal.component";

export default {
   name: "ETicketForm",
   components: { VueEditor, ConfirmationModalComponent },
   props: {
      isEditMode: {
         type: Boolean,
         default: false
      },
      toEditData: {
         type: Array | Object,
         default: () => ({})
      }
   },
   data() {
      return {
         form: {
            facility_id: window._app_facility.id,
            id: null,
            subject: '',
            coupon_type_id: null,
            plan_codes: [],
            no_plan_code: false,
            language_metadata:{}
         },
         initialForm: {
            facility_id: window._app_facility.id,
            id: null,
            subject: '',
            coupon_type_id: null,
            plan_codes: [],
            no_plan_code: false,
            language_metadata:{}
         },
         couponType: [
            { value: 1, text: this.$t('account-page-facility-my-page-e-ticket.type.1') },
            { value: 2, text: this.$t('account-page-facility-my-page-e-ticket.type.2') },
            { value: 3, text: this.$t('account-page-facility-my-page-e-ticket.type.3') },
            { value: 4, text: this.$t('account-page-facility-my-page-e-ticket.type.4') },
            { value: 5, text: this.$t('account-page-facility-my-page-e-ticket.type.5') },
         ],
         config: {
            current_language: "en",
            toolbar: [
               ["bold", "italic", "underline", "link"],
               [{ list: "ordered" }, { list: "bullet" }],
            ],
         },
         languages: [],
         showAlert: false,
         showErrorAlert: false,
      }
   },
   computed: {
      showError() {
         if(this.form.plan_codes.length <= 0 && this.form.no_plan_code == false){
            return this.$t('account-page-facility-my-page-e-ticket.form.plan_codes_description');
         }
         return false;
      },
      isValidForm() {
         // need to make it true to be disabled
         const needToHaveValue = (this.form.no_plan_code == false && this.form.plan_codes.length == 0)
         const hasTitle = (this.form.language_metadata?.[this.config.current_language]?.title || '').trim() == '';
         if(this.isEditMode != true) {
            return needToHaveValue || this.form.subject == '' ||  hasTitle
         } else {
            return needToHaveValue || this.form.id == '' || this.form.subject == '' || hasTitle
         }
      },
   },
   async mounted() {
      await this.initFormSetting();
   },
   methods: {
      handleChange(event){
         if(event === true) return this.form.plan_codes = [];
      },
      async initFormSetting() {
         const languagesResult = await this.$lionheart.get('/v2/facility-settings', { params: {
					facility_id: window._app_facility.id,
					name: 'language',
					paginate: 0					
				}})
				.then(r => r.data.data)
         if(languagesResult.length <= 0 ) {
            this.languages = [
               { code: 'en', name: 'en' },
               { code: 'ja', name: 'ja' }
            ];
         } else {
            this.languages = languagesResult[0].value;
         }

         this.initFormContents();
         // await this.getCouponType();
      },
      initFormContents() {
         this.languages.forEach((value, key) => {
            if (!this.form.language_metadata[value.code]) {
               // this.$set is important here to track the reactivity of an nested object
               this.$set(this.form.language_metadata, value.code, {
                  title: "",
                  content: ""
               });
            }
         });
         // use this to set the active tab
         const hasJapanese = this.languages.find(lang => lang.code === 'ja');
         if(hasJapanese && this.$i18n.locale == 'ja') {
            this.config.current_language = 'ja';
         }
      },
      async getCouponType() {
         const couponTypeResult = await this.$lionheart.get('/v2/facility-settings', { params: {
					facility_id: window._app_facility.id,
					name: 'coupon_type',
					paginate: 0					
				}})
				.then(r => r.data.data)
         if(couponTypeResult.length <= 0 ) {
            this.couponType = [
               { value: 1, text: "Unlimited" },
               { value: 2, text: "1 Time" },
               { value: 3, text: "2 Times" },
            ]
         } else {
            this.couponType = couponTypeResult.data;
         }
      },
      change_lang(language) {
         this.config.current_language = language;
         this.form.language_metadata[language].content = this.form.language_metadata[language].content ? this.form.language_metadata[language].content : " ";
         console.log(language);
      },
      onTagState(valid, invalid, duplicate) {
         this.invalidTags = invalid
         this.duplicateTags = duplicate
      },
      // validate if the input is less than 2 and greater than 20 character
      // validator(tag) {
      //    return tag.length > 2 && tag.length < 20
      // },
      submitForm() {
         if(this.isEditMode === true) {
            this.$bvModal.show('modal-confirmation');
            return;
         }
         this.submitCreateForm();

      },
      async submitCreateForm() {
         // if empty plan codes and did not check the no plan code it will automatically fall to no plan code
         if(this.form.no_plan_code == true || this.form.plan_codes.length <= 0){
            this.form.plan_codes = ['no_plan_code'];
         } 
         await this.$lionheart.post('/v2/coupons', this.form)
            .then((response) => {
               if(response.data.success) {
                  this.resetForm();
                  eventBus.$emit('closeCreateModal');
                  this.close();
               }
            }).catch((error) => {
               this.showErrorAlert = true;
               setTimeout(() => {
                  this.showErrorAlert = false
               }, 5000)
               this.$emit('scroll');
            });
      },
      async submitUpdateForm() {
         // if has plan codes but facility clicked the no plan code result will be no plan code
         if(this.form.no_plan_code == true || this.form.plan_codes.length <= 0){
            this.form.plan_codes = ['no_plan_code'];
         }
         await this.$lionheart.put('/v2/coupons/'+this.form.id, this.form)
            .then((response) => {
               if(response.data.success) {
                  this.$emit('scroll');
                  this.showAlert = true;
               }
            }).catch((error) => {
               this.showErrorAlert = true;
               setTimeout(() => {
                  this.showErrorAlert = false
               }, 5000)
               this.$emit('scroll');
            });
      },
      async resetForm() {
         const resetForm = JSON.parse(JSON.stringify(this.initialForm))
         Object.assign(this.form, resetForm);
         await this.initFormContents();
      },
      close() {
         this.$emit('close');
      },
   },
   watch: {
      isEditMode: {
         handler(newVal) {
            if(newVal == true) {
               this.form.id = this.toEditData.id;
               this.form.subject = this.toEditData.subject;
               this.form.coupon_type_id = this.toEditData.coupon_type_id;

               const planCodes = this.toEditData.plan_codes.filter((item) => {
                  if(item.plan_code == 'no_plan_code') return true;
               });

               if(planCodes.length == 0) {
                  const hasPlanCodes = [];
                  this.toEditData.plan_codes.forEach((item) => {
                     hasPlanCodes.push(item.plan_code)
                  })
                  this.form.plan_codes = hasPlanCodes
                  this.form.no_plan_code = false;
               } else {
                  this.form.no_plan_code = true;
                  this.form.plan_codes = [];
               }
               this.form.language_metadata = this.toEditData.language_metadata;
               this.form.facility_id = window._app_facility.id;
            } else {
               this.resetForm();
            }
         },
         // deep: true,
         immediate: true
      },
   }
}
</script>

<template>
   <div>
      <div class="col-lg-12" v-if="showAlert">
         <div class="alert alert-success" role="alert">
            {{ $t("account-page-facility-my-page-e-ticket.success_alert") }}
         </div>
      </div>
      <div class="col-lg-12" v-if="showErrorAlert">
         <div class="alert alert-danger" role="alert">
            {{ $t("account-page-facility-my-page-e-ticket.error_alert") }}
         </div>
      </div>
      <b-form @submit.prevent="submitForm" class="form">
         <div class="container">
            <div class="row">
               <div class="col-sm-12 col-lg-12">
                  <input type="hidden" v-model="form.id" />
   
                  <b-form-group
                     id="subject"
                     label-for="subject"
                     :description="$t('account-page-facility-my-page-e-ticket.form.subject_notes')"
                     label-cols-sm="4"
                     label-cols-lg="12"
                     content-cols-sm
                     content-cols-lg="12"
                     style="border-bottom: 1px solid;"
                  >
                     <template #label>
                        <div class="d-flex">
                           <span class="mr-1">{{ $t('account-page-facility-my-page-e-ticket.form.subject') }}</span>
                           <span class="text-danger">*</span>
                        </div>
                     </template>

                     <b-form-input
                        id="subject"
                        v-model="form.subject"
                        type="text"
                        placeholder="Enter Subject"
                        :autofocus="true"
                        :required="true"
                     ></b-form-input>
                  </b-form-group>
   
                  <b-form-group
                     id="fieldset-horizontal"
                     label-cols-sm="4"
                     label-cols-lg="2"
                     content-cols-sm
                     content-cols-lg="3"
                     label-for="type"
                  >
                     <template #label>
                        <div class="d-flex">
                           <span class="mr-1">{{ $t('account-page-facility-my-page-e-ticket.form.type') }}</span>
                           <span class="text-danger">*</span>
                        </div>
                     </template>

                     <b-form-select
                        v-model="form.coupon_type_id"
                        :options="couponType"
                        id="type"
                        size="md"
                        :required="true"
                     >
                        <template #first>
                           <b-form-select-option :value="null" disabled>-- {{ $t('account-page-facility-my-page-e-ticket.form.coupon_type_selection_text') }} --</b-form-select-option>
                        </template>
                     </b-form-select>
                  </b-form-group>
   
   
                  <b-form-group
                     id="fieldset-horizontal"
                     label-cols-sm="4"
                     label-cols-lg="2"
                     content-cols-sm
                     content-cols-lg="10"
                     label-for="planCodes"
                     >
                     <!-- :description="showError" -->
                     <template #label>
                        <div class="d-flex">
                           <span class="mr-1">{{ $t('account-page-facility-my-page-e-ticket.form.plan_codes') }}</span>
                           <span class="text-danger">*</span>
                        </div>
                     </template>
                     <!-- :tag-validator="validator" = for validation of tags -->
                      <div class="row align-items-end">
                        <div class="col-lg-6">
                           <b-form-tags
                              v-model="form.plan_codes"
                              @tag-state="onTagState"
                              input-id="planCodes"
                              separator=" ,;"
                              :placeholder="$t('account-page-facility-my-page-e-ticket.form.plan_codes_placeholder')"
                              no-add-on-enter
                              tag-variant="primary"
                              tag-pills
                              size="md"
                              :disabled="form.no_plan_code == true"
                           ></b-form-tags>
                        </div>

                        <div class="col-lg-6">
                           <b-form-checkbox
                              id="planCodeCheckBox"
                              v-model="form.no_plan_code"
                              name="planCodeCheckBox"
                              :value="true"
                              :unchecked-value="false"
                              size="lg"
                              @change="handleChange"
                           >
                              {{ $t('account-page-facility-my-page-e-ticket.form.no_plan_code') }}
                           </b-form-checkbox>
                        </div>
                     </div>
                  </b-form-group>
               </div>
               
               <!-- title and content -->
               <div class="col-lg-12 form-group">
                  <ul class="nav nav-tabs">
                     <li class="nav-item " v-if="languages.length" v-for="(value, key) in languages">
                           <a
                              class="nav-link"
                              :class="{ 'active': value.code == config.current_language }"
                              href="javascript:void(0)" @click="change_lang(value.code)"
                           >
                              {{ $t(`account-page-facility-language-option.${value.name}`) }}
                           </a>
                     </li>
                  </ul>
               </div>

               <template v-if="form.language_metadata[config.current_language]">
                  <div class="col-lg-12">
                     <b-form-group
                        id="title"
                        label-for="title"
                        :description="$t('account-page-facility-my-page-e-ticket.form.title_note')"
                        label-cols-sm="4"
                        label-cols-lg="12"
                        content-cols-sm
                        content-cols-lg="12"
                     >
                        <template #label>
                           <div class="d-flex">
                              <span class="mr-1">{{ $t('account-page-facility-my-page-e-ticket.form.title_label') }}</span>
                              <span class="text-danger">*</span>
                           </div>
                        </template>
                        
                        <input
                           id="title"
                           type="text"
                           class="form-control"
                           required
                           v-model="form.language_metadata[config.current_language].title"
                           :placeholder="$t('account-page-facility-my-page-e-ticket.form.title_placeholder_text')"
                        />
                     </b-form-group>
   
                     <b-form-group
                        id="description"
                        :label="$t('account-page-facility-my-page-e-ticket.form.description_label')"
                        label-for="description"
                        label-cols-sm="4"
                        label-cols-lg="12"
                        content-cols-sm
                        content-cols-lg="12"
                     >
                        <textarea
                           id="description"
                           class="form-control"
                           v-model="form.language_metadata[config.current_language].content"
                           rows="5"
                        >
                        </textarea>
                     </b-form-group>
   
                     <div align="center" class="col-lg-12 form-group">
                        <button type="button" class="btn btn-danger ml-3" @click="close">
                           {{ $t("account-page-facility-my-page-e-ticket.form.close_text") }}
                        </button>
                        <button type="submit" class="btn ml-3 btn-primary" :disabled="isValidForm">
                           {{ $t("account-page-facility-my-page-e-ticket.form.confirm_text") }}
                        </button>
                     </div>
                  </div>
               </template>

            </div>
         </div>
      </b-form>
      <ConfirmationModalComponent
         :message="config.message"
         @click-handler="submitUpdateForm"
      />
   </div>
</template>